export const debounce = (fn: Function, delay: number) => {
	let timer: number | undefined
	return (...args: any[]) => {
		if (timer) clearTimeout(timer)
		timer = setTimeout(() => fn(...args), delay)
	}
}
